module.exports = __webpack_public_path__ + "public/images/hero_image_bclp.6b8c06a837ef74f6f457ddfc8ad1cd7e.jpg";